/* @flow */
import React from 'react';

import createChainedFunction from 'utils/createChainedFunction.js';
import Formsy from 'lib/Formsy';
import Organization from 'entities/Organization';
import SchoolPicker from 'components/SchoolPicker.jsx';

/* A simple wrapped of SchoolPicker into a formzy mixin
 * So that the component can be used like any other formzy
 * component.
 */
const FormSchoolPicker = React.createClass({
  propTypes: {
    onCreateOrganization: React.PropTypes.func,
    onSelect: React.PropTypes.func,
  },

  mixins: [Formsy.Mixin],

  onChange(value: mixed) {
    this.setValue(value);
  },

  onCreateOrganization(org: Organization) {
    this.onChange(org.id);
    if (this.props.onCreateOrganization) {
      this.props.onCreateOrganization(org);
    }
  },

  render() {
    return (
      <SchoolPicker
        {...this.props}
        onSelect={createChainedFunction(value => this.onChange(value), this.props.onSelect)}
        onClear={() => this.onChange(null)}
        onCreateOrganization={this.onCreateOrganization}
      />
    );
  },
});

export default FormSchoolPicker;



// WEBPACK FOOTER //
// ./src/components/FormSchoolPicker.jsx